import * as c from "react";
var S = Object.defineProperty, O = (e, t, i) => t in e ? S(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, g = (e, t, i) => O(e, typeof t != "symbol" ? t + "" : t, i), _ = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new WeakMap(), M = 0, E = void 0;
function A(e) {
  return e ? (y.has(e) || (M += 1, y.set(e, M.toString())), y.get(e)) : "0";
}
function x(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? A(e.root) : e[t]}`).toString();
}
function T(e) {
  const t = x(e);
  let i = _.get(t);
  if (!i) {
    const n = /* @__PURE__ */ new Map();
    let u;
    const s = new IntersectionObserver((o) => {
      o.forEach((r) => {
        var h;
        const f = r.isIntersecting && u.some((a) => r.intersectionRatio >= a);
        e.trackVisibility && typeof r.isVisible > "u" && (r.isVisible = f), (h = n.get(r.target)) == null || h.forEach((a) => {
          a(f, r);
        });
      });
    }, e);
    u = s.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), i = {
      id: t,
      observer: s,
      elements: n
    }, _.set(t, i);
  }
  return i;
}
function N(e, t, i = {}, n = E) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const h = e.getBoundingClientRect();
    return t(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: h,
      intersectionRect: h,
      rootBounds: h
    }), () => {
    };
  }
  const { id: u, observer: s, elements: o } = T(i), r = o.get(e) || [];
  return o.has(e) || o.set(e, r), r.push(t), s.observe(e), function() {
    r.splice(r.indexOf(t), 1), r.length === 0 && (o.delete(e), s.unobserve(e)), o.size === 0 && (s.disconnect(), _.delete(u));
  };
}
function k(e) {
  return typeof e.children != "function";
}
var B = class extends c.Component {
  constructor(e) {
    super(e), g(this, "node", null), g(this, "_unobserveCb", null), g(this, "handleNode", (t) => {
      this.node && (this.unobserve(), !t && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = t || null, this.observeNode();
    }), g(this, "handleChange", (t, i) => {
      t && this.props.triggerOnce && this.unobserve(), k(this.props) || this.setState({ inView: t, entry: i }), this.props.onChange && this.props.onChange(t, i);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: e,
      root: t,
      rootMargin: i,
      trackVisibility: n,
      delay: u,
      fallbackInView: s
    } = this.props;
    this._unobserveCb = N(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: t,
        rootMargin: i,
        // @ts-ignore
        trackVisibility: n,
        // @ts-ignore
        delay: u
      },
      s
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: b, entry: v } = this.state;
      return e({ inView: b, entry: v, ref: this.handleNode });
    }
    const {
      as: t,
      triggerOnce: i,
      threshold: n,
      root: u,
      rootMargin: s,
      onChange: o,
      skip: r,
      trackVisibility: h,
      delay: f,
      initialInView: a,
      fallbackInView: p,
      ...w
    } = this.props;
    return c.createElement(
      t || "div",
      { ref: this.handleNode, ...w },
      e
    );
  }
};
function D({
  threshold: e,
  delay: t,
  trackVisibility: i,
  rootMargin: n,
  root: u,
  triggerOnce: s,
  skip: o,
  initialInView: r,
  fallbackInView: h,
  onChange: f
} = {}) {
  var a;
  const [p, w] = c.useState(null), b = c.useRef(), [v, I] = c.useState({
    inView: !!r,
    entry: void 0
  });
  b.current = f, c.useEffect(
    () => {
      if (o || !p) return;
      let l;
      return l = N(
        p,
        (m, C) => {
          I({
            inView: m,
            entry: C
          }), b.current && b.current(m, C), C.isIntersecting && s && l && (l(), l = void 0);
        },
        {
          root: u,
          rootMargin: n,
          threshold: e,
          // @ts-ignore
          trackVisibility: i,
          // @ts-ignore
          delay: t
        },
        h
      ), () => {
        l && l();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      p,
      u,
      n,
      s,
      o,
      i,
      h,
      t
    ]
  );
  const V = (a = v.entry) == null ? void 0 : a.target, R = c.useRef();
  !p && V && !s && !o && R.current !== V && (R.current = V, I({
    inView: !!r,
    entry: void 0
  }));
  const d = [w, v.inView, v.entry];
  return d.ref = d[0], d.inView = d[1], d.entry = d[2], d;
}
export {
  B as I,
  D as u
};
